import { IconButton, Tooltip } from "@mui/material";
import { IoIosClose } from "react-icons/io";
const CloseButton = ({ label = "Close", onClick = () => {}, disabled = false }) => {
  return (
    <Tooltip title={label}>
      <span>
        <IconButton onClick={onClick} disabled={disabled}>
          <IoIosClose />
        </IconButton>
      </span>
    </Tooltip>
  );
};
export default CloseButton;
